import { Box } from '../../ui';

export default function MessageContainer(props: {
  children: React.ReactNode;
  color?: string;
}) {
  return (
    <Box
      sx={{
        bg: props.color || 'blue10',
        p: 4,
        mt: 5,
        mb: 4,
      }}
    >
      {props.children}
    </Box>
  );
}
